import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Link,
    Collapse,
    Skeleton,
    IconButton,
    Tooltip,
    Menu,
    Grid,
    Button
} from "@mui/material";
import styles from '../my-data.module.scss';
import { observer } from "mobx-react";
import InfoForm from "./info_form";
import { ArrowDown2, ArrowUp2, MoreCircle } from "iconsax-react";
import DeleteSectionModal from "./delete-section-modal";
import ViewInfo from "./view-info";
import AddCustomFieldModal from "./add-custom-field-modal";
import CloneSectionModal from "./clone-section-modal";
import RenameSectionTitleModal from "./rename-section-title-modal";
import { getDisplayValueFromInfo } from "../../utils/data-utils";

const Section = observer(({
    section,
    editMode,
    labels,
    info,
    loading,
    update_info,
    language,
    index,
    uiStore,
    category,
    updateData,
    haveData,
    showFirst,
    sectionErrors,
}) => {
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState(null);


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleView = async () => {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    const firstLabel = labels.filter(i => {
        let current_info = info.filter(item => (item.label === i._id && i.infoType !== 'location'));

        if (i.required && current_info[0]?.infoValue) {
            return i;
        }
        return null
    })[0];

    const firstValue = info.filter(i => {
        if (i.label === firstLabel?._id) {
            return i;
        }

        return null;
    })[0];

    useEffect(() => {
        if (showFirst) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [showFirst]);

    return (
        <>
            <Box>
                {section.name !== 'Name' && section.name !== 'Nickname' && section.name !== 'Dates' && section.name !== 'Relationships' &&
                    <Box sx={{ display: 'flex', margin: '0 15px' }} children open={show}>
                        <Grid item xl={show ? 9 : 11} lg={show ? 9 : 11} md={show ? 9 : 11} sm={show ? 8 : 11}
                            xs={show ? 7 : 11}>
                            <Button
                                sx={{ justifyContent: 'flex-start', width: '100%', padding: '15px', borderRadius: 0 }}
                                onClick={toggleView}
                            >
                                <Typography fontWeight={600} sx={{ textAlign: 'left' }}>
                                    {section.name === section.title ? section?.title + ' ' + (index + 1) : section.title}
                                    {firstLabel?.name && <Box className={styles.collapseSubTitle}>
                                        <Typography>
                                            {getDisplayValueFromInfo(firstValue)}
                                        </Typography>
                                    </Box>}
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xl={show ? 3 : 1} lg={show ? 3 : 1} md={show ? 3 : 1} sm={show ? 4 : 1}
                            xs={show ? 5 : 1}
                            sx={{ display: 'flex', justifyContent: 'flex-end', alignContent: 'center' }}>
                            {((!section.mandatory && (section.name !== "Name" || section.name !== "Nickname")) || !language?.primary) &&
                                <Tooltip title="Options" sx={{ height: '100%', width: '70px' }}>
                                    <IconButton
                                        id="basic-button"
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClick}
                                    >
                                        <MoreCircle
                                            size="24"
                                            variant="Bulk"
                                        />
                                    </IconButton>
                                </Tooltip>
                            }

                            <IconButton sx={{ height: '100%', width: '70px' }} onClick={toggleView}>
                                {show ? <ArrowUp2 size="20" /> : <ArrowDown2 size="20" />}
                            </IconButton>
                        </Grid>
                    </Box>
                }

                <Collapse in={show || ['Name', 'Nickname', 'Dates', 'Relationships'].includes(section.name)} timeout={1000}>
                    {!!info?.length &&
                        <Collapse in={!editMode} timeout={1000}>
                            <Box>
                                {loading ?
                                    <>
                                        <Skeleton variant="rounded" className={styles.mydataInfoBlock} height={35}
                                            sx={{ mb: 2 }} />
                                        <Skeleton variant="rounded" className={styles.mydataInfoBlock} height={35}
                                            sx={{ mb: 2 }} />
                                    </>
                                    :
                                    labels.map(item => (
                                        <ViewInfo
                                            key={'view' + item._id}
                                            info={info?.find(i => i.label === item._id)}
                                            label={item}
                                            uiStore={uiStore}
                                        />
                                    ))
                                }
                            </Box>
                        </Collapse>
                    }

                    <Collapse in={editMode} timeout={1000}>
                        <Box className={styles.subSectionHeader}>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                slotProps={{
                                    paper: {
                                        elevation: 0,
                                        sx: {
                                            borderRadius: "8px",
                                            boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.07)',
                                            paddingTop: 0
                                        },
                                    }
                                }}
                            >
                                {/* {section.type === 'Custom' &&
                                        <RenameSectionModal uiStore={uiStore} section={section} category={category}
                                            updateData={updateData} />
                                    } */}

                                {!language?.primary &&
                                    <CloneSectionModal section={section} category={category?.name}
                                        language={language?.language} uiStore={uiStore}
                                        updateData={updateData} />
                                }

                                {!section.mandatory && (section.name !== "Name" || section.name !== "Nickname") &&
                                    <DeleteSectionModal
                                        section={section}
                                        category={category?.name}
                                        uiStore={uiStore}
                                        updateData={updateData}
                                    />
                                }
                                {!section.mandatory && (section.name !== "Name" || section.name !== "Nickname") &&
                                    <RenameSectionTitleModal
                                        uiStore={uiStore} section={section} category={category}
                                        updateData={updateData} handleCloseBtn={handleClose} index={index} />
                                }
                            </Menu>
                        </Box>

                        <Box className={`${styles.subForm}`}>
                            {labels?.map(item => (
                                <InfoForm
                                    key={item._id}
                                    info={info.find(i => i.label === item._id)}
                                    label={item}
                                    update_info={update_info}
                                    loading={!!loading}
                                    showAdvanced={showAdvanced}
                                    language={language}
                                    editMode={editMode}
                                    uiStore={uiStore}
                                    allErrors={errors}
                                    setAllErrors={setErrors}
                                    sectionErrors={sectionErrors}
                                    section={section}
                                    updateData={updateData}
                                    category={category}
                                />
                            ))}

                            {((!!labels.filter(i => {
                                let current_info = info.filter(item => (item.label === i._id));
                                return !i.required && !current_info[0]?.infoValue
                            })?.length) || (showAdvanced && section.customSortNumber > 0)) &&
                                <Link onClick={() => setShowAdvanced(val => !val)} fontSize={12}>
                                    {showAdvanced ? 'Show less' : 'Show more'}
                                </Link>
                            }

                            {((section.customSortNumber > 0) && category.name !== 'Dates') &&
                                <AddCustomFieldModal
                                    uiStore={uiStore}
                                    section={section}
                                    category={category}
                                    updateData={updateData}
                                />
                            }
                        </Box>
                    </Collapse>
                    {!editMode && !info?.length && category.name !== 'Name' &&
                        <Box className={styles.sectionHeader} sx={{ textAlign: 'center', display: 'block' }}>
                            No information added yet
                        </Box>
                    }
                </Collapse>
            </Box>
        </>
    );
});

export default Section;